import { Section } from './section';

export class Form {
  formTitle: string;
  sections: Section[];
}
